import { ChangeDetectionStrategy, Component, Input, Type } from '@angular/core';
import { QuestTaskStatusType } from 'angular-to-phaser';
import { QuestTaskStatus } from 'src/app/dto';
import { CashBalanceTaskComponent } from '../cash-balance-task/cash-balance-task.component';
import { NpcStateTaskComponent } from '../npc-state-task/npc-state-task.component';
import { PossessionTaskComponent } from '../possession-task/possession-task.component';

const QUEST_TASK_COMPONENT_REGISTRY: Record<QuestTaskStatusType, Type<unknown>> = {
    [QuestTaskStatusType.PossessionTaskStatus]: PossessionTaskComponent,
    [QuestTaskStatusType.CashBalanceTaskStatus]: CashBalanceTaskComponent,
    [QuestTaskStatusType.NpcStateTaskStatus]: NpcStateTaskComponent,
};

@Component({
    selector: 'app-quest-task-renderer',
    templateUrl: './quest-task-renderer.component.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class QuestTaskRendererComponent {
    @Input() task: QuestTaskStatus;

    get component(): Type<unknown> {
        return QUEST_TASK_COMPONENT_REGISTRY[this.task?.QuestTaskStatusType];
    }

    get inputs(): Record<string, unknown> {
        return { task: this.task };
    }
}
